/**
 * Represents path to node in hierarchical structure
 * @constructor
 * @param {Array} [path]
 */
class Path {
  constructor(private path: AnyFixMe[] = []) {}

  length() {
    return this.path.length;
  }

  append(segment: AnyFixMe) {
    if (segment === undefined) {
      throw new Error('segment should be defined');
    }

    return new Path(this.path.concat(segment));
  }

  private arraySelector(arr: AnyFixMe[], segment: AnyFixMe) {
    return arr?.[segment];
  }

  private arrayObjectSelector(
    obj: AnyFixMe,
    segment: AnyFixMe,
    prop: AnyFixMe,
  ) {
    return obj?.[prop]?.[segment];
  }

  private customFunctionSelector(
    obj: AnyFixMe,
    segment: AnyFixMe,
    fn: AnyFixMe,
  ) {
    return fn(obj, segment);
  }

  findIn(object: AnyFixMe, selector: AnyFixMe) {
    let root = object;
    let i, segment, getter;

    if (typeof selector === 'undefined') {
      getter = this.arraySelector;
    }

    if (typeof selector === 'string') {
      getter = this.arrayObjectSelector;
    }

    if (typeof selector === 'function') {
      getter = this.customFunctionSelector;
    }

    for (i = 0; root && i < this.path.length; i++) {
      segment = this.path[i];
      root = getter(root, segment, selector);
    }

    console.log(`Path.findIn -> ${root} / ${segment}`);

    return root;
  }

  parent() {
    const path = this.path.slice(0, this.path.length - 1);
    return new Path(path);
  }

  at(index: number) {
    if (typeof index !== 'number') {
      throw new Error('index should be a number');
    }

    return this.path[index];
  }

  first(n: number) {
    const sliced = this.path.slice(0, n || 1);
    return new Path(sliced);
  }

  atRight(index: number = 0) {
    return this.path[this.path.length - index - 1];
  }

  toString() {
    return this.path.join(', ');
  }

  equalsTo(path: AnyFixMe) {
    if (this === path) {
      return true;
    }

    if (path instanceof Path) {
      if (this.length() !== path.length()) {
        return false;
      }

      return this.path.every(function (x, i) {
        return x === path.path[i];
      });
    }

    return false;
  }

  startsWith(subpath: AnyFixMe, strictMatch: boolean) {
    if (subpath instanceof Path) {
      if (subpath.length() > this.length()) {
        return false;
      }

      if (strictMatch && subpath.length() === this.length()) {
        return false;
      }

      return subpath.path.every((x, i) => {
        return x === this.path[i];
      }, this);
    }

    return false;
  }

  inc(incrementValue?: number) {
    if (this.length() === 0) {
      return new Path([0]);
    }

    const path = this.path.slice();

    if (incrementValue === undefined) {
      path[path.length - 1] += 1;
    } else {
      path[path.length - 1] += incrementValue;
    }

    return new Path(path);
  }

  dec(decrementValue?: number) {
    if (decrementValue === undefined) {
      return this.inc(-1);
    }

    return this.inc(-decrementValue);
  }

  increment(lv: number) {
    let path;

    if (this.length() === lv) {
      path = this.append(0);
    } else {
      path = this.first(lv + 1);
      path.path[lv] += 1;
    }

    return path;
  }
}
export default Path;
